import { useEffect, useState } from "react";

/**
 * Returns true once `delayMs` has elapsed while `active` stays true, and resets
 * to false when `active` goes false.
 *
 * Used to surface a "waking the service up" notice on the first request of a
 * review session. There is intentionally no warmup timer keeping the backend
 * SQL database hot (cost — see finding F35), so the Serverless DB may be
 * auto-paused; resuming it can take up to ~1 minute. The backend rides out the
 * resume via a connect retry, so the request still succeeds — this notice just
 * reassures the user that the longer-than-usual wait is expected, not a hang.
 */
export function useSlowLoadNotice(active: boolean, delayMs = 8000): boolean {
  const [slow, setSlow] = useState(false);

  useEffect(() => {
    if (!active) {
      setSlow(false);
      return;
    }
    const timer = setTimeout(() => setSlow(true), delayMs);
    return () => clearTimeout(timer);
  }, [active, delayMs]);

  return slow;
}
